import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { RepositoryMediaFile, RepositoryService } from '../services/repository.service';


@Injectable({
  providedIn: 'root',
})
export class DocumentsGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(private router: Router, private repositoryService: RepositoryService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    const requestId = next.queryParams['id'];
    let media: RepositoryMediaFile | null = null;
    const result = await this.repositoryService.validateTokenAndGetMediaById(requestId, token!);
    this.loggedInStatus = result.valid;
    media = await result.media;

    if (this.loggedInStatus && media) {
      this.router.navigate(['/documents', media?.url, media!.name]);
    } else {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
